module.exports = __webpack_public_path__ + "static/img/-v-4.19bb8fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/-v-4.png
// module id = Qahn
// module chunks = 0